import { I18n } from '@calendly/i18n';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { useCallback, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useGetUserProfile } from 'common';
import { createPhoneNumberUuidSelector, phoneNumbersPresentSelector, phoneNumbersLimitReachedSelector, PhoneNumberField } from 'features/phone_numbers';
import { useBooleanState } from 'hooks/useBooleanState';
const titleCss = "tbu1yjc";
const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)} />;
});
const fieldBlockCss = "f1u0we7d";
const FieldBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldBlockCss, props.className)} />;
});
export const PhoneNumberAdding = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const phoneNumberUuid = useSelector(createPhoneNumberUuidSelector(phoneNumber));
  const {
    owner_id: ownerId
  } = useGetUserProfile();
  const limitReached = useSelector(phoneNumbersLimitReachedSelector);
  const phoneNumbersPresent = useSelector(phoneNumbersPresentSelector);
  const [isFieldVisible, showField, hideField] = useBooleanState(!phoneNumbersPresent);
  const onChange = useCallback(value => {
    setPhoneNumber(value);
    if (phoneNumberUuid) {
      hideField();
      setPhoneNumber('');
    }
  }, [hideField, phoneNumberUuid]);
  if (limitReached) return null;
  if (!isFieldVisible && phoneNumbersPresent) {
    return <MinimalButton fontSize="medium" spacingTop={8} onClick={showField}>
        {I18n.t('publisher.workflows.actions.sms.add_another_number')}
      </MinimalButton>;
  }
  return <FieldBlock data-component="phone-number-field-block" data-testid="phone-number-field-block">
      {phoneNumbersPresent && <Title>{I18n.t('publisher.account_settings.phone_numbers.new.title')}</Title>}

      <PhoneNumberField onChange={onChange} phoneNumber={phoneNumber} ownerId={ownerId} />
    </FieldBlock>;
};

require("./phone_number_adding.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./phone_number_adding.js");